<template>
  <footer class="header-bd">


    <div id="fundo" class="h-bg"></div>

    <div class="container cont py-3 h-bg">
      <div class="row">
        <div class="col-md my-2">

          <div class="d-flex ">

            <div class="logo">
              <img :src="dados.imagem_url" alt="">
            </div>

            <div class="ml-3">
              <h3>{{dados.nome}}</h3>
              <h4>{{dados.fone}}</h4>
              <p>{{dados.endereco}}</p>

            </div>

          </div>



        </div>
        <div class="col-md my-2">
          <div class="row">
            <div class="col">
              <h5>Horários de Funcionamento</h5>
            </div>
          </div>

          <div class="row" v-if="expediente.fulltime==0">
            <div class="col">

              <p><strong>Segunda:</strong> <template v-if="expediente.seg_fc==1">das {{ expediente.seg_inicio.substr(0,5) }} às {{ expediente.seg_fim.substr(0,5) }}</template> <span class="text-danger" v-else>Fechado</span> </p>
              <p><strong>Terça:</strong> <template v-if="expediente.ter_fc==1">das {{ expediente.ter_inicio.substr(0,5) }} às {{ expediente.ter_fim.substr(0,5) }}</template> <span class="text-danger" v-else>Fechado</span> </p>
              <p><strong>Quarta:</strong> <template v-if="expediente.qua_fc==1">das {{ expediente.qua_inicio.substr(0,5) }} às {{ expediente.qua_fim.substr(0,5) }}</template> <span class="text-danger" v-else>Fechado</span> </p>
              <p><strong>Quinta:</strong> <template v-if="expediente.qui_fc==1">das {{ expediente.qui_inicio.substr(0,5) }} às {{ expediente.qui_fim.substr(0,5) }}</template> <span class="text-danger" v-else>Fechado</span> </p>


            </div>
            <div class="col">

              <p><strong>Sexta: </strong> <template v-if="expediente.sex_fc==1">das {{ expediente.sex_inicio.substr(0,5) }} às {{ expediente.sex_fim.substr(0,5) }}</template> <span class="text-danger" v-else>Fechado</span> </p>
              <p><strong>Sabado:</strong> <template v-if="expediente.sab_fc==1">das {{ expediente.sab_inicio.substr(0,5) }} às {{ expediente.sab_fim.substr(0,5) }}</template> <span class="text-danger" v-else>Fechado</span> </p>
              <p><strong>Domingo:</strong> <template v-if="expediente.dom_fc==1">das {{ expediente.dom_inicio.substr(0,5) }} às {{ expediente.dom_fim.substr(0,5) }}</template> <span class="text-danger" v-else>Fechado</span> </p>

            </div>
          </div>

          <div v-else class="row">
            <div class="col">
              <p>Aberto 24 horas!</p>
            </div>
          </div>



        </div>
        <div class="col-md-2 text-center my-2 d-flex flex-column align-items-center">

          <h6>Desenvolvido por:</h6>
          <img src="/images/vsmenu.png" alt=""  style="max-height: 70px;width: max-content;">
          <a href="https://vsmenu.com.br" target="_blank" >www.vsmenu.com.br</a>

        </div>
      </div>
    </div>




  </footer>
</template>

<script>
import api from "../service/api";
import Cookie from "js-cookie";
export default {

  data() {
        return {
            dados: {},
            expediente: {}

        }
    },

    methods: {
      async carregarDados(){
          await api
          .get('/inquilino')
          .then(response => (this.dados = response.data));
        },

        async carregarExpediente(){
          await api
          .get('/inquilino/expediente')
          .then(response => (this.expediente = response.data));
        },

        modalLogin(){
          Cookie.set('proximaPagina', 'perfil' );
          $('#modalLogin').modal('show');
        },
    },

    computed: {

        logado() {

          if (JSON.stringify(this.$store.state.perfil.main)==='{}') {
            return false
          }else{
            return true
          }
        },
    },

    mounted () {
        this.carregarDados();
        this.carregarExpediente();
    },

}
</script>

<style scoped>

footer {
  position: relative;
  bottom: 0;
  left: 0;
  width: 100%;
  font-size: 0.8rem;
}

footer p {
  margin-bottom: 0.5rem;
}

footer h5{
  border-bottom: 1px solid #999;
}

footer a {
  color: var(--hn1);
}

#fundo {
  content: "";
  height:145px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  filter: blur(3px);
  z-index: -1;
  opacity: 0.85;
}


.cont{
  /* height:150px; */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  box-shadow: 0 0 12px 1px #272727;
}

.logo{
  height: 100%;
  border-radius: 20%;
  /* box-shadow: 0 0 12px 1px #666666; */
}

.logo img{
  max-width:300px;
  max-height:120px;
  filter: drop-shadow(0 0 6px #666666);
  /* box-shadow: 0 0 12px 1px #666666;
  border-radius: 15px; */
}

</style>
